export class Reservation {
  CompanyID: string;
  ResDate:string;
  ReserveItems:[] = [];
  StoreNo:string;
  SelectedTime:string;
}

export class ServiceItem {
  /**服務名稱 */
  Service: string;
  /**狀態 */
  Status: CheckStatus;
  /**圖示 */
  Icon: string;
  /**是否關閉 */
  Disabled: boolean;
  /**風格 */
  Class: string;
}

export enum CheckStatus {
  /**選取 */
  Checked,
  /**未選取 */
  Unchecked
}

export class ResSearch{
  CompanyID: string;
  StoreNo:string;
  StoreName:string;
  Type:string;
  PetNo:string;
  PetName:string;
  MemberName:string;
  RemindDateS:string;
  RemindDateE:string;
  TargetNo:string;
  TimeFrom:string;
  TimeTo:string;
  Service:string;
  Room:string;
  Price:number;
  Content: string;
  ConsumeDate: string;
  SaleNo: string;
  ReservationFlag: string;
  SignPath: string;
  UserID: string;
}